import FundsDistribution from '../../../components/core-v2/organisms/funds-distribution'
import FundsReinvestment, {
  ExpectedReinvestmentData
} from '../../../components/core-v2/organisms/funds-reinvestment'
import { ExDateSchedule } from '../types/exDateSchedule'

export type FundExDatePreviousFormProps = {
  exDate: ExDateSchedule
  expectedReinvestmentData: ExpectedReinvestmentData
}

const FundExDatePreviousForm = (props: FundExDatePreviousFormProps) => {
  const { exDate, expectedReinvestmentData } = props
  return (
    <>
      <FundsDistribution
        readOnly
        finSwitchDistribution={exDate.finSwitchDistribution}
        finalDistribution={exDate.finalDistribution}
      />
      <FundsReinvestment
        readOnly
        exDate={exDate.dateStr}
        expectedReinvestmentData={expectedReinvestmentData}
        finSwitchReinvestment={exDate.finSwitchReinvestment}
        finalReinvestment={exDate.finalReinvestment}
      />
    </>
  )
}

export default FundExDatePreviousForm
